import React from "react";

interface ServiceSchemaProps {
  name: string;
  description: string;
  provider: string;
  areaServed: string[];
  serviceType: string;
  url: string;
  offers?: {
    name: string;
    description: string;
    priceRange?: string;
  }[];
}

export const ServiceSchema: React.FC<ServiceSchemaProps> = ({
  name,
  description,
  provider,
  areaServed,
  serviceType,
  url,
  offers = []
}) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": name,
    "description": description,
    "provider": {
      "@type": "Organization",
      "name": provider,
      "url": "https://sol-vi.nl"
    },
    "areaServed": areaServed.map(area => ({
      "@type": "Place",
      "name": area
    })),
    "serviceType": serviceType,
    "url": url,
    "hasOfferCatalog": offers.length > 0 ? {
      "@type": "OfferCatalog",
      "name": `${name} Aanbiedingen`,
      "itemListElement": offers.map((offer, index) => ({
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": offer.name,
          "description": offer.description
        },
        "priceRange": offer.priceRange || undefined
      }))
    } : undefined
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
};

export default ServiceSchema;